// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ZtZZ","inner":"Footer_inner__1Eeud"};